/**
 * Bridge from the portal's MUI palette-path colour keys onto DS semantic
 * tokens. The statusTokens contract still speaks "success.main" /
 * "text.disabled" (callers and tests depend on those strings); the ledger
 * primitives resolve them here so nothing downstream knows MUI existed.
 */

/** Text/foreground resolution — status words read as text, not swatches. */
export const paletteTextClass: Record<string, string> = {
  "text.primary": "text-content-primary",
  "text.secondary": "text-content-secondary",
  "text.disabled": "text-content-disabled",
  "primary.main": "text-content-accent",
  "error.main": "text-content-error",
  "success.main": "text-content-success",
  "warning.main": "text-content-warning",
  "info.main": "text-content-info",
};

/**
 * Filled-swatch resolution for the status dot: a dot is a surface chip, so it
 * takes the surface status tokens (the same family Chip/Alert fill with).
 */
export const paletteSurfaceClass: Record<string, string> = {
  "success.main": "bg-surface-success",
  "warning.main": "bg-surface-warning",
  "error.main": "bg-surface-error",
  "info.main": "bg-surface-info",
  "text.disabled": "bg-content-disabled",
  "text.secondary": "bg-content-secondary",
};

/** Class for a known palette path, or undefined when the caller passed CSS. */
export function paletteText(color: string): string | undefined {
  return paletteTextClass[color];
}
